module.exports = __webpack_public_path__ + "static/img/direct_hit_movie_thum_01.00d254d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/direct_hit_movie_thum_01.jpg
// module id = DfS9
// module chunks = 0